import { render, staticRenderFns } from "./BCXMessengerChatInput.vue?vue&type=template&id=67ebd5b8&scoped=true"
import script from "./BCXMessengerChatInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatInput.vue?vue&type=style&index=0&id=67ebd5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ebd5b8",
  null
  
)

export default component.exports